import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import SmallDetails from "./SmallDetails";
import { CompanyPreview } from "components/PreviewPanel/Company/CompanyPreviewPanel";
import { BookkeepingPreview } from "components/PreviewPanel/Bookkeeping/BookkeepingPreviewPanel";
import { ContactPreview } from "components/PreviewPanel/contact/ContactPreviewPanel";
import { BankAccountPreview } from "components/PreviewPanel/BankAccount/BankAccountPreviewPanel";
import FormattedAddress from "components/Atoms/FormattedAddress";

interface ContactSmallProps {
  contact: server.dto.ContactSmallV2
}

export const ContactSmallDetails = (props: ContactSmallProps) => {
  return <SmallDetails
    label={<ContactPreview
      contactId={props.contact.contactId}
      trigger={<a tabIndex={0}>{props.contact.name.fullName}</a>}
    />}
  />
}

interface CompanySmallProps {
  company: server.dto.CompanySmall
  layout: "multiLine" | "singleLine"
  onChange?: () => void
}

export const CompanySmallDetails = (props: CompanySmallProps) => {
  if (props.layout === "singleLine") return <SmallDetails
    label={<CompanyPreview
      companyId={props.company.companyId}
      trigger={<a tabIndex={0}>{props.company.name}</a>}
      onChange={props.onChange}
    />}
    subLabel={props.company.cityCountry}
  />

  return <div>
    <CompanyPreview
      companyId={props.company.companyId}
      trigger={<a tabIndex={0}>{props.company.name}</a>}
      onChange={props.onChange}
    />
    <FormattedAddress address={props.company.address} />
  </div>
}
  ;

interface InvoiceSmallProps {
  invoice: server.dto.InvoiceSmall
}

export const InvoiceSmallDetails = (props: InvoiceSmallProps) =>
  <SmallDetails
    label={props.invoice.documentNumber}
    link={props.invoice.isV1
      ? routes.invoice_Detail(props.invoice.invoiceId).absolute
      : routes.invoiceV2_Detail(props.invoice.invoiceId).absolute}
  />;

interface BookkeepingSmallProps {
  bookkeeping: server.dto.BookkeepingSmall
}

export const BookkeepingSmallDetails = (props: BookkeepingSmallProps) =>
  <SmallDetails
    label={<BookkeepingPreview
      bookkeepingId={props.bookkeeping.bookkeepingId}
      trigger={<a tabIndex={0}>{props.bookkeeping.name}</a>}
    />}
    subLabel={props.bookkeeping.code}
  />

interface BankAccountSmallProps {
  bankAccount: server.dto.BankAccountSmall
}

export const BankAccountSmallDetails = (props: BankAccountSmallProps) =>
  <SmallDetails
    label={<BankAccountPreview
      bankAccountId={props.bankAccount.bankAccountId}
      trigger={<a tabIndex={0}>{props.bankAccount.title}</a>}
    />
    }
    subLabel={props.bankAccount.beneficiaryName}
  />